module.exports = __webpack_public_path__ + "static/media/wedding-catering-7.905d1842.jpg";